/* esm.sh - @unhead/react@3.1.0/dist/shared/react.DF9T1fqs */
import{createContext as t}from"react";var o=t(null);export{o as U};
//# sourceMappingURL=react.DF9T1fqs.mjs.map